import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import credithelpimg from '../../assets/img/credithelp.png'
import '../../assets/style/gtos.css'

function HelpGradeToSgpa(){
    return(
        <>
         <div class="p-4 p-md-5 mb-4 rounded text-body-emphasis mt-3" style={{background:"#c9edec"}}>
    <div class="col-lg-6 px-0">
      <h1 class="display-4 fst-italic">How to Use <span style={{color:"#05b9b3"}}>Grade to SGPA Converter</span></h1>
      <p class="lead my-3">This post will help you to calculate SGPA from Grades using GPA converter.</p>
    </div>
  </div>



<Grade/>
  
        </>
    )
}



const grades = {
  "EX": 10.0,
  "AA": 9.0,
  "AB": 8.5,
  "BB": 8.0,
  "BC": 7.5,
  "CC": 7.0,
  "CD": 6.5,
  "DD": 6.0,
  "DE": 5.5,
  "EE": 5.0
};


function Grade(){
  return(
    <>
        <div className='container mt-2 mb-5'>
        <h3>GRADE to SGPA converter</h3>
        <hr />
        <div class="input-group mb-3">
  <span  class="input-group-text bg-uni"  ><label htmlFor='ns' style={{"cursor":"pointer"}}>Total no. of subjects</label></span>
  <input id='ns' class="form-control" min="0" max="20" placeholder="e.g. 7 (except audit subjects)" type="number"   />
</div>


<table className="table">
          <thead>
            <tr>
              <th>Course code</th>
              <th>Credit</th>
              <th>Grade</th>
            </tr>
          </thead>
          <tbody>
            
              <tr >
                <td>BTCO504A</td>
                <td>3</td>
                <td>
                  <select className='form-select form-select-sm ' >

                  {Object.keys(grades).map((grade) => (
                      <option key={grade} value={grade}>{grade}</option>
                    ))}
                     
                  
                    
                  </select>
                </td>
              </tr>
          
          </tbody>
        </table>

</div>
    </>
  )
}

export default HelpGradeToSgpa;
